import moment from 'moment';
import {User} from '../../generated/smg_service_pb';
import {dateFormat} from '../constants';

// Why a signed-in user may not play yet. The screen that shows the matching message and the code that only needs to know
// whether the user may play (without opening any modal) read the same rules from here.
export type UserAccessBlock = 'terms' | 'kyc-duplicate' | 'kyc-mismatch' | 'photo' | 'under-18' | 'self-limitation';

// The order is the order in which the screen reports a problem: the first one that applies wins.
export const getUserAccessBlock = (user: User | undefined, isFullSwing: boolean): UserAccessBlock | undefined => {
  if (!user?.tncAccepted) return 'terms';
  if (user.kycStatus === 5) return 'kyc-duplicate';
  if (user.kycStatus === 6) return 'kyc-mismatch';
  if (!isFullSwing && !user.photoAccepted) return 'photo';
  if (user.dateOfBirth && moment().diff(moment(user.dateOfBirth, dateFormat), 'years') < 18) return 'under-18';
  if (user.selfLimitationConfirmed) return 'self-limitation';

  return undefined;
};
